<template>
  <div>
    <label for="">
      {{ label }} {{ required ? '*' : '' }}
    </label>
    <v-text-field
        :rules="[...this.isRequired,...rules]"
        class="q-text-field"
        dense
        hide-details="auto"
        outlined
        required
        v-bind="$attrs"
        @input="$emit('input', $event)"
        :value="value"
    />
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isRequired() {
      return this.required ? [(v) => !!v || `${this.label} is required`] : []
    }
  }
}
</script>

<style scoped>

</style>